import script from "./ChatWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatWindow.vue?vue&type=script&setup=true&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=5d3b3178&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d3b3178"]])

export default __exports__